import { useDispatch, useSelector } from 'react-redux';
import {
  closeModal,
  openModal,
  selectOpenModal,
} from '../../redux/slices/modals';
import CustomizeCardModal from './CustomizeCard';
import WalletModal from './Wallet';
import SelectCardModal from './SelectCard';
import AddFundsModal from './AddFunds';
import SettingsModal from './Settings';
import WithdrawFundsModal from './WithdrawFunds';
import DetectDeposit from './DetectingDeposit';
import ConfirmationModal from './Confirmation';
import BridgeOnrampModal from './BridgeOnramp';
import KYCRejection from './KYCRejection';
import WithdrawOrDeposit from './WithdrawOrDeposit/index';
import Referrals from './Referrals';
import GiftClaimed from './GiftClaimed';
import SelectToken from './SelectToken';
import ShareGiftModal from './ShareGift';
import GiveAway from './GiveAway';
import DebitCardWaitlist from './DebitCardWaitlist';
import LoadingModal from './Loading';
import DoubleGiftModal from './DoubleGift/index.jsx';
import DiversifyModal from './Diversify/index.jsx';
import CardRevealModal from './CardReveal/index.jsx';
import PaymentSuggestionModal from './PaymentSuggestion';
import VerifyPhoneNumberModal from './VerifyPhoneNumber/index.jsx';
import ApplePayModal from './ApplePay/index.jsx';
import AmountSelector from './AmountSelector/index.jsx';
import { usePrivy } from '@privy-io/react-auth';
import { useEffect, useState } from 'react';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../common/responsive.js';
import GiftFlowModal from './GiftFlowModal/index.jsx';
import CreatePrepaidCard from './CreatePrepaidCard/index.jsx';
import DownloadAppModal from './DownloadAppModal/index.jsx';
import PaymentFailedModal from './PaymentFailed/index.jsx';

const modalsMapping = {
  customizeCard: CustomizeCardModal,
  wallet: WalletModal,
  selectCardTheme: SelectCardModal,
  addFunds: AddFundsModal,
  withdrawFunds: WithdrawFundsModal,
  settings: SettingsModal,
  detectDeposit: DetectDeposit,
  confirmation: ConfirmationModal,
  bridgeOnramp: BridgeOnrampModal,
  kycRejection: KYCRejection,
  withdrawOrDeposit: WithdrawOrDeposit,
  referrals: Referrals,
  giftClaimed: GiftClaimed,
  selectToken: SelectToken,
  shareGift: ShareGiftModal,
  giveAway: GiveAway,
  debitCardWaitlist: DebitCardWaitlist,
  doubleGift: DoubleGiftModal,
  loading: LoadingModal,
  diversify: DiversifyModal,
  cardReveal: CardRevealModal,
  paymentSuggestion: PaymentSuggestionModal,
  verifyPhoneNumber: VerifyPhoneNumberModal,
  applePay: ApplePayModal,
  amountSelector: AmountSelector,
  giftFlow: GiftFlowModal,
  createPrepaidCard: CreatePrepaidCard,
  downloadApp: DownloadAppModal,
  paymentFailed: PaymentFailedModal,
};

const Modals = ({ user }) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };
  const modal = useSelector(selectOpenModal);
  const { isModalOpen } = usePrivy();
  const [openBackModal, setOpenBackModal] = useState(null);
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  useEffect(() => {
    if (!isMobile) {
      return;
    }
    if (isModalOpen) {
      handleClose();
      if (modal.name) {
        setOpenBackModal(modal);
      }
    } else {
      if (openBackModal) {
        dispatch(
          openModal({ name: openBackModal.name, props: openBackModal.props }),
        );
        setOpenBackModal(null);
      }
    }
  }, [isModalOpen, openBackModal, modal, isMobile]);

  if (!modal?.name) {
    return <></>;
  } else {
    const Modal = modalsMapping[modal.name];

    if (!Modal) {
      console.error(
        `Modal "${modal.name}" not found in modalsMapping. Available modals:`,
        Object.keys(modalsMapping),
      );
      return <></>;
    }

    return <Modal {...modal.props} user={user} onClose={handleClose} />;
  }
};

export default Modals;
